import React, { useState } from "react";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

function PasswordInput({ formik, name, label, claseCSS }) {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleClickMouseDownPassword = () => setShowPassword(!showPassword);

    return (
        <TextField
            variant="outlined"
            className={claseCSS}
            label={label}
            type={showPassword ? "text" : "password"} // <-- This is where the magic happens
            id={name}
            name={name}
            value={formik.values[name]}
            onChange={formik.handleChange}
            InputProps={{
                // <-- This is where the toggle button is added.
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleClickMouseDownPassword}
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            error={formik.touched[name] && Boolean(formik.errors[name])}
            helperText={formik.touched[name] && formik.errors[name]}
        />
    );
}

export default PasswordInput;
